import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SendTo.svg",
  "use": "SendTo.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SendTo.svg\"><path d=\"M35.2845,48.57a2.0031,2.0031,0,0,1-3.2853-1.5376V39.0211c-10.2014.0027-16.4428,3.532-18.6954,10.835a1.6711,1.6711,0,0,1-1.602,1.1647,1.7,1.7,0,0,1-1.6891-1.7741c.5218-14.86,7.7127-23.4982,21.9865-24.2249V17.0079A2.0031,2.0031,0,0,1,35.2845,15.47L53.3112,30.4821a2.0009,2.0009,0,0,1,0,3.0753Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol